module.exports = __webpack_public_path__ + "img/behance.b1472543.svg";